import apiUrls from "../store/apiUrls";
import { apiCachedGet } from "./apiService";
import { CustomSalonData, Salon } from "../interfaces/services/Salon";

const CUSTOM_SLN_NS = "CUSTOM_SLN:";
const SLN_NS = "SLN:";
const CUSTOM_CK = {
  item: (code: string) => `${CUSTOM_SLN_NS}salon:${code}`,
  path: (code: string) => `${SLN_NS}path:${code}`,
};
const salonService = {
  getCustomSalonData: (salonCode: string): Promise<CustomSalonData> => {
    const url = `${apiUrls.salon.customSalonData.getCustomSalonData}/${salonCode}`;
    return apiCachedGet<CustomSalonData>("SALON", url, {
      ttl: 10 * 60 * 1000,
      store: "memory",
      keyExtra: CUSTOM_CK.item(salonCode),
      swr: false,
    });
  },
  getSalonWithPath: (path: string): Promise<Salon> => {
    const url = `${apiUrls.salon.salon.salonByPath}/${path}`;
    return apiCachedGet<Salon>("SALON", url, {
      ttl: 10 * 60 * 1000,
      store: "memory",
      keyExtra: CUSTOM_CK.path(path),
      swr: false,
    });
  },
};

export default salonService;
